
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getCreatePriceDtoFormGroup() {
return new FormGroup({
    itemId: new FormControl<number | undefined>(undefined, [Validators.required]),
    priceChf: new FormControl<number | undefined>(undefined),
    priceEur: new FormControl<number | undefined>(undefined),
    purchaseChf: new FormControl<number | undefined>(undefined),
    saleChf: new FormControl<number | undefined>(undefined),
    saleChfExcl: new FormControl<number | undefined>(undefined),
    validFrom: new FormControl<string | undefined>('', [Validators.required]),
    validTo: new FormControl<string | undefined>('', [Validators.required]),
    materialSalePrice: new FormControl<number | undefined>(undefined),
    workSalePrice: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    isFactorBased: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    priceFactor: new FormControl<number | undefined>(undefined),
    basepriceItemId: new FormControl<number | undefined>(undefined),
})
;
}
      